import { useState, useEffect, useRef } from "react";
import { api } from "../../context";

export default function Events({ t }) {
  const [events, setEvents] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [viewTickets, setViewTickets] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [verifyNum, setVerifyNum] = useState("");
  const [verifyResult, setVerifyResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [flash, setFlash] = useState("");
  const eventFileRef = useRef(null);
  const [eventImage, setEventImage] = useState(null);
  const [eventImagePreview, setEventImagePreview] = useState(null);
  const [form, setForm] = useState({
    title: "", description: "", venue: "", location: "",
    event_date: "", event_time: "", time_end: "",
    age_min: 18, age_max: 99, image_url: "",
    ticket_types: [
      { name: "Early Bird", price: 500, total_tickets: 50, benefits: [] },
      { name: "Regular", price: 1000, total_tickets: 100, benefits: [] },
      { name: "VIP", price: 2500, total_tickets: 20, benefits: ["Dedicated entrance", "Free welcome drink", "Reserved seating"] },
    ]
  });

  const CARD=t.card,BORDER=t.border,TEXT=t.text,SUB=t.sub,PRI=t.pri,GRN=t.grn,RED=t.red,GOLD=t.gold;
  const fmt = (n) => Number(n || 0).toLocaleString();
  const showFlash = (msg) => { setFlash(msg); setTimeout(() => setFlash(""), 3000); };
  const INP = { width: "100%", padding: "10px 14px", borderRadius: 10, border: `1px solid ${BORDER}`, background: t.input, color: TEXT, fontSize: 13, outline: "none", boxSizing: "border-box", fontFamily: "inherit" };

  const load = async () => {
    setLoading(true);
    const r = await api("/admin/events/admin/list");
    if (r.ok) setEvents(r.data || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const updateTT = (idx, field, val) => {
    const tt = [...form.ticket_types];
    tt[idx] = { ...tt[idx], [field]: ["price","total_tickets","age_min","age_max"].includes(field) ? (parseInt(val)||0) : val };
    setForm({ ...form, ticket_types: tt });
  };

  const addBenefit = (idx) => {
    const b = prompt("Enter benefit:");
    if (!b) return;
    const tt = [...form.ticket_types];
    tt[idx] = { ...tt[idx], benefits: [...(tt[idx].benefits||[]), b] };
    setForm({ ...form, ticket_types: tt });
  };

  const save = async () => {
    if (!form.title || !form.venue || !form.location || !form.event_date) { showFlash("Fill required fields"); return; }
    const validTT = form.ticket_types.filter(t2 => t2.name && t2.price >= 0 && t2.total_tickets > 0);
    if (!validTT.length) { showFlash("Add at least 1 ticket type"); return; }
    const fd = new FormData();
    ["title","description","venue","location","event_date","event_time","time_end"].forEach(k => fd.append(k, form[k]));
    fd.append("age_min", form.age_min); fd.append("age_max", form.age_max);
    if (eventImage) fd.append("image", eventImage);
    else if (form.image_url) fd.append("image_url", form.image_url);
    validTT.forEach((tt, i) => {
      fd.append(`ticket_types[${i}][name]`, tt.name);
      fd.append(`ticket_types[${i}][price]`, tt.price);
      fd.append(`ticket_types[${i}][total_tickets]`, tt.total_tickets);
      (tt.benefits||[]).forEach((b, j) => fd.append(`ticket_types[${i}][benefits][${j}]`, b));
    });
    const token = localStorage.getItem("gc_token");
    const r = await fetch("/api/admin/events/admin/create", { method: "POST", headers: { Authorization: `Bearer ${token}`, Accept: "application/json" }, body: fd })
      .then(async res => ({ ok: res.ok, data: await res.json().catch(() => null) }));
    if (r.ok) { showFlash("Event created! 🎉"); setShowAdd(false); load(); }
    else showFlash(r.data?.message || "Failed");
  };

  const updateStatus = async (id, status) => {
    const r = await api(`/admin/events/admin/${id}/status`, { method: "POST", body: JSON.stringify({ status }) });
    if (r.ok) { showFlash("Status updated"); load(); }
  };

  const loadTickets = async (id) => {
    setViewTickets(id);
    const r = await api(`/admin/events/admin/${id}/tickets`);
    if (r.ok) setTickets(r.data || []);
  };

  const doVerify = async () => {
    if (!verifyNum) return;
    const r = await api("/admin/events/admin/verify-ticket", { method: "POST", body: JSON.stringify({ ticket_number: verifyNum }) });
    if (r.ok) setVerifyResult(r.data);
    else { setVerifyResult(null); showFlash("Ticket not found"); }
  };

  const markVerified = async (ticketId) => {
    const r = await api(`/admin/events/admin/tickets/${ticketId}/mark-verified`, { method: "POST" });
    if (r.ok) { showFlash("Entry confirmed! ✓"); doVerify(); }
  };

  // Tickets modal
  if (viewTickets) return (
    <div>
      {flash && <div style={{ position: "fixed", top: 20, right: 20, background: GRN, color: "#fff", padding: "10px 20px", borderRadius: 10, fontWeight: 700, fontSize: 13, zIndex: 9999 }}>{flash}</div>}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div style={{ fontSize: 20, fontWeight: 800, color: TEXT }}>Event Tickets ({tickets.length})</div>
        <button onClick={() => setViewTickets(null)} style={{ padding: "8px 16px", borderRadius: 9, border: `1px solid ${BORDER}`, background: "transparent", color: SUB, fontSize: 13, cursor: "pointer" }}>← Back to Events</button>
      </div>
      <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ background: t.hover, borderBottom: `2px solid ${BORDER}` }}>
              {["User", "Ticket #", "Type", "Amount", "Phone", "Status", "Verified"].map(h => (
                <th key={h} style={{ padding: "12px 16px", textAlign: "left", fontSize: 10, fontWeight: 700, color: SUB, textTransform: "uppercase" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tickets.map((tk, i, arr) => (
              <tr key={tk.id} style={{ borderBottom: i < arr.length - 1 ? `1px solid ${BORDER}` : "none" }}>
                <td style={{ padding: "12px 16px", fontWeight: 700, color: TEXT }}>{tk.user?.name}</td>
                <td style={{ padding: "12px 16px", fontFamily: "monospace", color: PRI, fontSize: 12 }}>{tk.ticket_number}</td>
                <td style={{ padding: "12px 16px", color: SUB }}>{tk.ticket_type?.name}</td>
                <td style={{ padding: "12px 16px", fontWeight: 700, color: GRN }}>KES {fmt(tk.amount_paid)}</td>
                <td style={{ padding: "12px 16px", color: SUB, fontSize: 12 }}>{tk.phone}</td>
                <td style={{ padding: "12px 16px" }}>
                  <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700, background: tk.payment_status === "completed" ? `${GRN}20` : `${GOLD}20`, color: tk.payment_status === "completed" ? GRN : GOLD }}>{tk.payment_status}</span>
                </td>
                <td style={{ padding: "12px 16px" }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: tk.is_verified ? GRN : GOLD }}>{tk.is_verified ? "✓ Verified" : "Pending"}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!tickets.length && <div style={{ textAlign: "center", padding: "40px 0", color: SUB }}>No tickets sold yet</div>}
      </div>
    </div>
  );

  return (
    <div>
      {flash && <div style={{ position: "fixed", top: 20, right: 20, background: GRN, color: "#fff", padding: "10px 20px", borderRadius: 10, fontWeight: 700, fontSize: 13, zIndex: 9999 }}>{flash}</div>}

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: TEXT }}>🎉 Events</div>
          <div style={{ fontSize: 12, color: SUB, marginTop: 4 }}>{events.length} total events</div>
        </div>
        <button onClick={() => setShowAdd(!showAdd)} style={{ padding: "10px 20px", borderRadius: 10, border: "none", background: PRI, color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
          {showAdd ? "✕ Cancel" : "+ Create Event"}
        </button>
      </div>

      {/* Ticket verifier */}
      <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px", marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 12 }}>🔍 Ticket Verifier</div>
        <div style={{ display: "flex", gap: 10, marginBottom: verifyResult ? 16 : 0 }}>
          <input value={verifyNum} onChange={e => setVerifyNum(e.target.value.toUpperCase())} placeholder="Enter ticket number (GE-XXXXXXXX)"
            onKeyDown={e => e.key === "Enter" && doVerify()}
            style={{ ...INP, flex: 1, fontFamily: "monospace", textTransform: "uppercase" }} />
          <button onClick={doVerify} style={{ padding: "10px 20px", borderRadius: 10, border: "none", background: PRI, color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>Verify</button>
        </div>
        {verifyResult && (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, padding: 16, borderRadius: 12, background: verifyResult.payment_status === "completed" ? `${GRN}08` : `${RED}08`, border: `1px solid ${verifyResult.payment_status === "completed" ? GRN : RED}30`, marginTop: 12 }}>
            {[["Ticket #", verifyResult.ticket_number], ["Name", verifyResult.user_name], ["Phone", verifyResult.phone], ["Amount", `KES ${fmt(verifyResult.amount_paid)}`], ["Type", verifyResult.ticket_type], ["Event", verifyResult.event], ["Date", verifyResult.event_date], ["Payment", verifyResult.payment_status], ["Verified", verifyResult.is_verified ? `Yes (${verifyResult.verified_at})` : "Not yet"]].map(([l, v], i) => (
              <div key={i}>
                <div style={{ fontSize: 10, color: SUB, fontWeight: 700, textTransform: "uppercase", marginBottom: 2 }}>{l}</div>
                <div style={{ fontSize: 13, fontWeight: 700, color: TEXT }}>{v}</div>
              </div>
            ))}
            {!verifyResult.is_verified && verifyResult.payment_status === "completed" && (
              <div style={{ gridColumn: "1/-1" }}>
                <button onClick={() => markVerified(verifyResult.id)} style={{ width: "100%", padding: "12px 0", borderRadius: 10, border: "none", background: GRN, color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>✓ Confirm Entry</button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Create form */}
      {showAdd && (
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px", marginBottom: 20 }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: TEXT, marginBottom: 16 }}>Create New Event</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
            <div style={{ gridColumn: "1/-1" }}><input placeholder="Event title *" value={form.title} onChange={e => setForm({...form, title: e.target.value})} style={INP} /></div>
            <textarea placeholder="Description" value={form.description} onChange={e => setForm({...form, description: e.target.value})}
              style={{ ...INP, gridColumn: "1/-1", height: 80, resize: "vertical" }} />
            <input placeholder="Venue name *" value={form.venue} onChange={e => setForm({...form, venue: e.target.value})} style={INP} />
            <select value={form.location} onChange={e => setForm({...form, location: e.target.value})} style={INP}>
              <option value="">Select County *</option>
              {"Nairobi,Mombasa,Kisumu,Nakuru,Kiambu,Kajiado,Kilifi,Machakos,Eldoret".split(",").map(c => <option key={c} value={c}>{c}</option>)}
            </select>
            <input type="datetime-local" value={form.event_date} onChange={e => setForm({...form, event_date: e.target.value})} style={INP} />
            <div style={{ display: "flex", gap: 8 }}>
              <input placeholder="Start time (e.g. 9PM)" value={form.event_time} onChange={e => setForm({...form, event_time: e.target.value})} style={{...INP, flex: 1}} />
              <input placeholder="End time (e.g. 3AM)" value={form.time_end} onChange={e => setForm({...form, time_end: e.target.value})} style={{...INP, flex: 1}} />
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <input type="number" placeholder="Min age" value={form.age_min} onChange={e => setForm({...form, age_min: parseInt(e.target.value)||18})} style={{...INP, flex: 1}} />
              <input type="number" placeholder="Max age" value={form.age_max} onChange={e => setForm({...form, age_max: parseInt(e.target.value)||99})} style={{...INP, flex: 1}} />
            </div>
          </div>

          {/* Image upload */}
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: TEXT, marginBottom: 8 }}>Event Poster</div>
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={() => eventFileRef.current?.click()} style={{ padding: "10px 16px", borderRadius: 10, border: `1.5px dashed ${PRI}`, background: `${PRI}08`, color: PRI, fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
                {eventImage ? "📷 Change" : "📷 Upload Poster"}
              </button>
              <input ref={eventFileRef} type="file" accept="image/*" style={{ display: "none" }}
                onChange={e => { const f = e.target.files[0]; if (f) { setEventImage(f); const rd = new FileReader(); rd.onload = ev => setEventImagePreview(ev.target.result); rd.readAsDataURL(f); } }} />
              <input placeholder="Or paste image URL" value={form.image_url} onChange={e => setForm({...form, image_url: e.target.value})} style={{...INP, flex: 1}} />
            </div>
            {eventImagePreview && <div style={{ marginTop: 10, borderRadius: 10, overflow: "hidden", height: 120, width: 200 }}><img src={eventImagePreview} style={{ width: "100%", height: "100%", objectFit: "cover" }} alt="preview" /></div>}
          </div>

          {/* Ticket types */}
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: TEXT, marginBottom: 10 }}>Ticket Types</div>
            {form.ticket_types.map((tt, i) => (
              <div key={i} style={{ background: t.input, borderRadius: 12, padding: 14, marginBottom: 10, border: `1px solid ${BORDER}` }}>
                <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                  <input placeholder="Type name" value={tt.name} onChange={e => updateTT(i, "name", e.target.value)} style={{...INP, flex: 2}} />
                  <input type="number" placeholder="Price" value={tt.price} onChange={e => updateTT(i, "price", e.target.value)} style={{...INP, flex: 1}} />
                  <input type="number" placeholder="Qty" value={tt.total_tickets} onChange={e => updateTT(i, "total_tickets", e.target.value)} style={{...INP, flex: 1}} />
                  <button onClick={() => setForm({...form, ticket_types: form.ticket_types.filter((_,idx) => idx !== i)})}
                    style={{ padding: "0 12px", borderRadius: 8, border: "none", background: `${RED}15`, color: RED, fontSize: 16, cursor: "pointer", flexShrink: 0 }}>✕</button>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                  {(tt.benefits||[]).map((b, j) => (
                    <div key={j} style={{ display: "flex", alignItems: "center", gap: 4, padding: "3px 10px", borderRadius: 20, background: `${PRI}15`, border: `1px solid ${PRI}30` }}>
                      <span style={{ fontSize: 11, color: PRI }}>{b}</span>
                      <button onClick={() => { const tt2=[...form.ticket_types]; tt2[i]={...tt2[i],benefits:tt2[i].benefits.filter((_,idx)=>idx!==j)}; setForm({...form,ticket_types:tt2}); }}
                        style={{ background: "none", border: "none", color: RED, cursor: "pointer", fontSize: 12, padding: 0 }}>✕</button>
                    </div>
                  ))}
                  <button onClick={() => addBenefit(i)} style={{ padding: "3px 10px", borderRadius: 20, border: `1px dashed ${PRI}`, background: "transparent", color: PRI, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>+ Benefit</button>
                </div>
              </div>
            ))}
            <button onClick={() => setForm({...form, ticket_types: [...form.ticket_types, {name:"",price:0,total_tickets:50,benefits:[]}]})}
              style={{ width: "100%", padding: "10px 0", borderRadius: 10, border: `1.5px dashed ${BORDER}`, background: "transparent", color: SUB, fontSize: 13, cursor: "pointer" }}>+ Add Ticket Type</button>
          </div>

          <button onClick={save} style={{ width: "100%", padding: "14px 0", borderRadius: 12, border: "none", background: `linear-gradient(135deg, ${PRI}, #a23ad1)`, color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer" }}>🎉 Create Event</button>
        </div>
      )}

      {/* Events table */}
      {loading
        ? <div style={{ textAlign: "center", padding: 40, color: SUB }}>Loading events...</div>
        : !events.length
          ? <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "60px 24px", textAlign: "center" }}>
              <div style={{ fontSize: 40, marginBottom: 16 }}>🎉</div>
              <div style={{ fontSize: 16, fontWeight: 700, color: TEXT }}>No events yet</div>
              <div style={{ fontSize: 13, color: SUB, marginTop: 8 }}>Create your first event above</div>
            </div>
          : <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, overflow: "hidden" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                <thead>
                  <tr style={{ background: t.hover, borderBottom: `2px solid ${BORDER}` }}>
                    {["Event", "Date", "Venue", "Tickets", "Revenue", "Status", "Actions"].map(h => (
                      <th key={h} style={{ padding: "12px 16px", textAlign: "left", fontSize: 10, fontWeight: 700, color: SUB, textTransform: "uppercase" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {events.map((ev, i, arr) => (
                    <tr key={ev.id} style={{ borderBottom: i < arr.length - 1 ? `1px solid ${BORDER}` : "none" }}>
                      <td style={{ padding: "14px 16px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                          {ev.image_url && <img src={ev.image_url} style={{ width: 40, height: 40, borderRadius: 8, objectFit: "cover" }} alt="" />}
                          <div>
                            <div style={{ fontSize: 13, fontWeight: 700, color: TEXT }}>{ev.title}</div>
                            <div style={{ fontSize: 11, color: SUB }}>{ev.ticket_types?.map(tt => `${tt.name}: KES ${fmt(tt.price)}`).join(" · ")}</div>
                          </div>
                        </div>
                      </td>
                      <td style={{ padding: "14px 16px", fontSize: 12, color: TEXT, whiteSpace: "nowrap" }}>{new Date(ev.event_date).toLocaleDateString("en", { month: "short", day: "numeric", year: "numeric" })}</td>
                      <td style={{ padding: "14px 16px", fontSize: 12, color: SUB }}>{ev.venue}</td>
                      <td style={{ padding: "14px 16px", fontSize: 13, fontWeight: 700, color: TEXT }}>{ev.tickets_count || 0}</td>
                      <td style={{ padding: "14px 16px", fontSize: 13, fontWeight: 700, color: GRN }}>KES {fmt(ev.ticket_types?.reduce((a, tt) => a + tt.price * tt.sold_count, 0))}</td>
                      <td style={{ padding: "14px 16px" }}>
                        <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700, background: ev.status === "upcoming" ? `${PRI}20` : ev.status === "completed" ? `${GRN}20` : `${RED}20`, color: ev.status === "upcoming" ? PRI : ev.status === "completed" ? GRN : RED }}>{ev.status}</span>
                      </td>
                      <td style={{ padding: "14px 16px" }}>
                        <div style={{ display: "flex", gap: 6 }}>
                          <button onClick={() => loadTickets(ev.id)} style={{ padding: "5px 10px", borderRadius: 8, border: "none", background: `${PRI}15`, color: PRI, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Tickets</button>
                          {ev.status === "upcoming" && <>
                            <button onClick={() => updateStatus(ev.id, "completed")} style={{ padding: "5px 10px", borderRadius: 8, border: "none", background: `${GRN}15`, color: GRN, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Complete</button>
                            <button onClick={() => updateStatus(ev.id, "cancelled")} style={{ padding: "5px 10px", borderRadius: 8, border: "none", background: `${RED}15`, color: RED, fontSize: 11, fontWeight: 700, cursor: "pointer" }}>Cancel</button>
                          </>}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
      }
    </div>
  );
}